/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_V2_Auto_Scroll_DescriptionInputs */

const en_settings_v2_auto_scroll_description = /** @type {(inputs: Settings_V2_Auto_Scroll_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep the highlighted sentence in view while listening`)
};

const es_settings_v2_auto_scroll_description = /** @type {(inputs: Settings_V2_Auto_Scroll_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantiene a la vista la frase resaltada mientras escuchas`)
};

/**
* | output |
* | --- |
* | "Keep the highlighted sentence in view while listening" |
*
* @param {Settings_V2_Auto_Scroll_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_v2_auto_scroll_description = /** @type {((inputs?: Settings_V2_Auto_Scroll_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_V2_Auto_Scroll_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_v2_auto_scroll_description(inputs)
	return en_settings_v2_auto_scroll_description(inputs)
});